/**
 * algolia-product-page.js
 * 
 * Global javascript object for handling Algolia events in product page.
 */
window.algoliaProductPage = {
  userToken: null,
  objectId: null,
  queryId: null,

  init: function() {
    let self = this;
    self.initFields();
    self.attachAddToCartBtnEventListener();
  },

  attachAddToCartBtnEventListener: function() {
    let self = this;
    let addToCartBtn = document.querySelector('.add-to-cart');
    if (addToCartBtn && addToCartBtn.disabled == false) {
      addToCartBtn.addEventListener('click', self.sendAddToCartConversionEvent.bind(self));
    }
  },

  // Send conversion event to Algolia
  sendAddToCartConversionEvent: function() {
    let self = this,
        token = self.getUserToken(),
        objectId = self.getObjectId(),
        queryId = self.getQueryId();

    if (!token || !objectId) {
      return;
    }

    let data = {
      userToken: token,
      index: 'shopify_prod_products',
      eventName: 'PDP;Product added to cart',
      queryID: queryId,
      objectIDs: [objectId]
    };

    if (!data.queryID) {
      delete data.queryID;
    }

    // Send a conversion event
    if (queryId) {
      // event is related to a previous search
      window.aa('convertedObjectIDsAfterSearch', data);
    } else {
      // event is not related to a previous search
      window.aa('convertedObjectIDs', data);
    }
  },

  // Initialize object properties
  initFields: function() {
    let self = this;
    self.userToken = window.algoliaShopify.getAlgoliaUserToken();
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('queryId')) {
      self.queryId = urlParams.get('queryId');
    }
    if (urlParams.has('objectId')) {
      self.objectId = urlParams.get('objectId');
    } else {
      let skuMeta = document.querySelector("meta[itemprop='sku']");
      if (skuMeta) {
        let sku = skuMeta.getAttribute('content');
        // fetch product object id from Algolia using prouduct's sku
        window.algoliaShopify.getProductObjectIdBySku(sku).then((objectId) => {
          self.objectId = objectId;
        });
      }
    }
  },

  getUserToken: function() {
    return this.userToken;
  },

  getObjectId: function() {
    return this.objectId;
  },

  getQueryId: function() {
    return this.queryId;
  }
};

window.addEventListener('load', function() {
  window.algoliaProductPage.init();
});
